// @flow
import * as React from 'react'
import PassengerIcon from 'mz-icons/passenger'
import NumberField from '../NumberField'
import SelectField from '../SelectField'
import { isMobileBrowser } from '../../utils'

// Types
import type { Props as BaseFieldProps } from '../../core/BaseField'

export type Appearance = 'mobile-native' | 'desktop' | 'mobile'
export type Props = BaseFieldProps & {
  fieldAppearance?: Appearance,
  min: number,
  max: number,
}

/**
 * Field for changing number of passengers (in search form for example)
 * @param  {Object} props
 * @return {React.Element}
 */
class PassengersNumberField extends React.Component<Props> {
  static defaultProps = {
    min: 1,
    max: 99,
    renderPrefix: () => <PassengerIcon />,
  }

  handleBlur = () => {
    const {
      min,
      input: { value, onChange, onBlur },
    } = this.props

    if (!value) {
      onChange && onChange(min)
    }

    onBlur && onBlur()
  }

  render() {
    const { fieldAppearance, min, max, ...props } = this.props

    const hasAppearance = Object.prototype.hasOwnProperty.call(
      props,
      'fieldAppearance'
    )
    const finalAppearance =
      !hasAppearance && isMobileBrowser() ? 'mobile-native' : fieldAppearance

    const inputProps = {
      ...props.input,
      onBlur: this.handleBlur,
    }

    if (finalAppearance === 'mobile-native') {
      const options = [...Array(max + 1).keys()].slice(min)

      return (
        <SelectField
          {...props}
          input={inputProps}
          fieldAppearance="native"
          options={options}
        />
      )
    }

    return <NumberField {...props} input={inputProps} min={min} max={max} />
  }
}

export default PassengersNumberField
